let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("ddz4Z")]).then(() => parcelRequire('7Zzmn'));